import Analytics from '@module/analytics';

class ClickTracker {
  static instance;

  constructor(config) {
    if (ClickTracker.instance) {
      return ClickTracker.instance;
    }

    ClickTracker.instance = this;
    this.body = config.body;
    this.handlers = this.generateHandlers(config.track);
    this.page = config.page;
    this.attached = false;
  }

  attach = () => {
    if (this.attached) {
      return;
    }

    this.handlers.forEach((h) => h.attach());
    this.attached = true;
  };

  remove = () => {
    this.handlers.forEach((h) => h.remove());
    ClickTracker.instance = null;
  };

  generateHandlers = (settings) => {
    return settings
      .map((setting) => {
        return this.setHandler(setting);
      })
      .filter(Boolean);
  };

  setHandler = (settings) => {
    const handler = () => {
      Analytics.trackSnowplowEvent({
        category: this.page,
        action: settings.action,
        label: settings.label,
      });

      if (typeof settings.tracker === 'function') {
        settings.tracker();
      }
    };

    const element = this.body.node.querySelector(settings.selector);

    if (!element) {
      return null;
    }

    return {
      attach: () => {
        element.addEventListener('click', handler);
      },
      remove: () => {
        element.removeEventListener('click', handler);
      },
    };
  };
}

export default ClickTracker;
